Fancybox.bind('[data-fancybox="gallery"]', {
// Your custom options for a specific gallery
});

Fancybox.bind('[data-fancybox="actu"]', {
// Your custom options for a specific gallery
});
